import React from "react";
import {Helmet} from "react-helmet";

class PageTitle extends React.Component {

  	render() {
		return (
			<div className="Page_Title">
	            <Helmet>
			        <title>Search Engine Optimization Services | Digipanda</title>
			        <meta name="description" content="Best SEO Services Company - Internet Marketing Agency" />
			    </Helmet>
			</div>
		);
	}
};

export default PageTitle;
